import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import { form as formStyle } from '@/styles';

const ChartDescriptionTile = ({ chart }) => {
  const { ChartTitle, ChartDescription } = chart;

  return (
    <div css={formStyle.gridCol}>
      <div>{ChartTitle}</div>
      <div>{ChartDescription}</div>
    </div>
  );
};

ChartDescriptionTile.propTypes = {
  chart: PropTypes.object.isRequired,
};

export default ChartDescriptionTile;
